import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useTranslation } from '../useTranslation';
import { NavLink } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
const { t } = useTranslation();
   const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

 // Basic email validation
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    setMessage('Veuillez entrer une adresse email valide"');
    return;
  }
  
  setIsLoading(true);
  setIsLoading(true);
    
    try {
      const { error } = await supabase
        .from('newsletter_subscriptions')
        .insert([{ email }]);
      
      if (error) throw error;
      
      setMessage(t('subscriptionSuccess'));
      setEmail('');
    } catch (error) {
      setMessage(error.message.includes('duplicate key') 
        ? 'Vous êtes déjà abonné!'
        : 'Échec de l’abonnement. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  return (
    <>
<footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="footer-info">
              <h3>Domaine Numidya</h3>
              <p>
          Km 14, GP17 
                   <br />
  Tabarka, Tunisie<br /><br />
  <strong>{t('phoneLabel')}</strong> +216 98 370 055<br />
  <strong>Email:</strong> rafikbj@gmail.com<br />
</p>
              <div class="social-links mt-3">
                <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
                <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>Navigation</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/">{t('Home')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/Apropos">{t('about')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/boutique">{t('boutique')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/contact">{t('Contact')}</NavLink></li>
               <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="https://terroir.numidia.pro/">Terroir Numidya</NavLink></li>
</ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>{t('ourServices')}</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/restaurant">{t('Restaurant')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/chalet">{t('Chalet')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/Musee">{t('Musée')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/Huillerie">{t('Huillerie')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/Academie">{t('Académie')}</NavLink></li>
            </ul>
          </div>

 <div className="col-lg-4 col-md-6 footer-newsletter">
        <h4>Newsletter</h4>
        <p>{t('newsletterText')}</p>
        <form onSubmit={handleSubmit}>
          <input 
            type="email" 
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('emailPlaceholder')} 
            required
          />
        <input 
  type="submit" 
  value={isLoading ? t('subscribing') : t('signUp')} 
  disabled={isLoading}/>
        </form>
        {message && (
          <div className={`newsletter-message ${
            message.includes('Thank you') ? 'success' : 'error'
          }`}>
            {message}
          </div>
        )}
      </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        &copy; Copyright <strong><span>Domaine Numidya</span></strong>. {t('allRightsReserved')}
      </div>
      <div class="credits">   
        {t('createdBy')} <a href="">Amine Makni</a>
      </div>
    </div>
  </footer>

  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
  </>
  );
};

export default Footer;
